export default __webpack_public_path__ + "static/resource2-cdada7549656310e11ea042ce691f5f1.png";